import { history } from '../redux/store';

export function navegarAFicha(val) {
  history.push({ pathname: '/vertical/lectura-ficha', state: val });
}